/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ContactSiegeSearch
 */
export interface ContactSiegeSearch {
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeSearch
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContactSiegeSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ContactSiegeSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ContactSiegeSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ContactSiegeSearch interface.
 */
export function instanceOfContactSiegeSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactSiegeSearchFromJSON(json: any): ContactSiegeSearch {
    return ContactSiegeSearchFromJSONTyped(json, false);
}

export function ContactSiegeSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactSiegeSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ContactSiegeSearchToJSON(value?: ContactSiegeSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsiegeSocial': value.idsiegeSocial,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

